module.exports = __webpack_public_path__ + "static/scale-model-of-the-pagoda-at-patterson-park-in-baltimore-maryland-90bccdb82b89b1af7dca8a28b0f5f2fe.png";